// frictionforce.js
import React, { useState } from "react";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Kalkulator Gaya Gesek - Hitung Gaya Gesek Online";
const DESCRIPTION =
  "Kalkulator gaya gesek menghitung gaya gesek berdasarkan percepatan dan massa.";
const KEYWORDS = "gaya gesek, menghitung gaya gesek, kalkulator gesekan";
const OG_URL = "https://do-calculate.com/calculator/id/frictionforce";
function FrictionForceCalculator() {
  const [acceleration, setAcceleration] = useState("");
  const [mass, setMass] = useState("");
  const [frictionalForce, setFrictionalForce] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!acceleration || !mass) {
      setError("Harap masukkan percepatan dan massa dengan benar");
      setFrictionalForce("");
      return;
    }
    const accelerationValue = parseFloat(acceleration);
    const massValue = parseFloat(mass);
    if (isNaN(accelerationValue) || isNaN(massValue) || massValue <= 0) {
      setError("Harap masukkan nilai yang valid dan positif untuk percepatan dan massa");
      setFrictionalForce("");
      return;
    }
    const frictionalForceValue = accelerationValue * massValue;
    setFrictionalForce(frictionalForceValue.toFixed(2));
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div>
            <div className="row">
              <div>
                <p>Untuk menghitung gaya gesek, kita perlu mengetahui percepatan dan massa.</p>
                <p>Gaya gesek dapat dihitung menggunakan rumus berikut:</p>
                <p>
                  <b>Gaya Gesek (F) = Percepatan (a) × Massa (m)</b>
                </p>
                <p>
                  Dimana:
                  <br />
                  F: Gaya gesek (dalam satuan Newton).
                  <br />
                  a: Percepatan (dalam satuan m/s²).
                  <br />
                  m: Massa (dalam satuan kg).
                </p>
                <p>
                  Gunakan kalkulator berikut untuk menghitung gaya gesek berdasarkan percepatan dan massa.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Percepatan (m/s²)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="9.8"
                        value={acceleration}
                        onChange={(e) => setAcceleration(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Massa (kg)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="10"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Gaya Gesek
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {frictionalForce !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Gaya Gesek (Newton): {frictionalForce} Newton
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Gaya dorong = Gaya resultan - Gaya gesek kinetik
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default FrictionForceCalculator;